var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-accordion-container" },
    [
      _c("accordion", {
        class: _vm.color,
        attrs: { items: _vm.products },
        scopedSlots: _vm._u(
          [
            {
              key: "accordion-selector-title",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c("span", {
                    staticClass: "title",
                    domProps: { innerHTML: _vm._s(item.post_title) }
                  })
                ]
              }
            },
            {
              key: "accordion-item-header-title",
              fn: function(ref) {
                var item = ref.item
                var itemIndex = ref.itemIndex
                return [
                  _c(
                    "div",
                    { staticClass: "title with-icon" },
                    [
                      _vm._t("product-icon-" + itemIndex),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "text",
                        domProps: { innerHTML: _vm._s(item.post_title) }
                      })
                    ],
                    2
                  )
                ]
              }
            },
            {
              key: "accordion-item-content",
              fn: function(ref) {
                var item = ref.item
                var itemIndex = ref.itemIndex
                return [
                  _c(
                    "div",
                    { staticClass: "container" },
                    [
                      _c("highlight-item", {
                        attrs: { options: _vm.getHighlightOptions(item) },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "custom-column",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "col case-study-container" },
                                    [_vm._t("custom-column-" + itemIndex)],
                                    2
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ]
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }